import axios from "axios";
let axiosClient = null;

export const createAxios = (token) => {
  axiosClient = axios.create({
    baseURL: `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

// Centralized error handling function (example)
const handleError = (error) => {
  // Handle error here or pass it to callback
  console.error("API Error:", error);
};

export async function getAudioList(params, callback) {
  try {
    const res = await axiosClient.post("/policy-audio/list", params);
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export async function loadVehicleByVehicleGroup(params, callback) {
  try {
    const res = await axiosClient.post(
      "/vehicle/vehicle-by-vehicle-group",
      params
    );
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export async function loadVehicleGroup(params, callback) {
  try {
    const res = await axiosClient.post(
      "/vehicle-group/vehicle-group-by-company",
      params
    );
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export async function loadVehicle(params, callback) {
  try {
    const res = await axiosClient.post("/vehicle/vehicle-by-company", params);
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export async function loadPlants(params, callback) {
  try {
    const res = await axiosClient.post("/getplant", params);
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export async function createBroadcastToIcing(params, callback) {
  try {
    const res = await axiosClient.post("/broadcast-config/create", params);
    callback(200, res);
  } catch (error) {
    handleError(error);
    window.alert("เกิดข้อผิดพลาด");
  }
}

export async function updateBroadcastToIcing(id, params, callback) {
  try {
    const res = await axiosClient.post(
      `/broadcast-config/update/${id}`,
      params
    );
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export async function deleteBroadcastToIcing(id, callback) {
  try {
    const res = await axiosClient.delete(`/broadcast-config/delete/${id}`);
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export async function getBroadcastToIcingById(id, callback) {
  try {
    const res = await axiosClient.get(`/broadcast-config/${id}`);
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export async function getBroadcastToIcingList(params, callback) {
  try {
    const res = await axiosClient.post("/broadcast-config/getall", params);
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export async function updateStatusById(id, params, callback) {
  try {
    const res = await axiosClient.post(
      `/broadcast-config/update-isactive/${id}`,
      params
    );
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export async function loadLocationGroup(params, callback) {
  try {
    const res = await axiosClient.post(`/all-locationgroup`, params);
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export async function loadLocationByLocationGroup(params, callback) {
  try {
    const res = await axiosClient.post("/location-by-location-group", params);
    callback(200, res);
  } catch (error) {
    handleError(error);
  }
}

export default axiosClient;
